export default function sharedObservable(observable) {
  return {
    init: function init() {
      this.bus = observable;
    },
  };
}
